import { TuvisMessagingPhone } from "@whatslly/types/tuvis-messaging/TuvisMessagingPhones";
import { getPrettyPhone } from "@whatslly/commons/utils";

export function getPhoneName(phone?: TuvisMessagingPhone) {
  switch (phone?.type) {
    case "whatsapp":
      return phone.verified_name;
    case "twilio":
      return phone.name;
    case "imessage":
      return phone.name;
  }
  return "";
}

export function getPhoneNumber(phone?: TuvisMessagingPhone) {
  switch (phone?.type) {
    case "whatsapp":
      return getPrettyPhone(phone.phone);
    case "twilio":
      return getPrettyPhone(phone.phone);
    case "imessage":
      return getPrettyPhone(phone.phone);
  }
  return "";
}
